import type React from 'react';

import type { CardViewEnum } from '../tokens/card';
import type { ResolutionEnumNoPrefix } from './OrderAnalytic';
import type { UnifiedLiquidityEnum } from './types';

export interface MarketDataCardsContextProps {
  showPlaceholderCards: () => void;
  hidePlaceholderCards: () => void;
  saveCard: (nextCard: MarketDataCardConfig) => void;
  deleteCard: (card: MarketDataCardConfig) => void;
  cardFilter: string;
  setCardFilter: React.Dispatch<React.SetStateAction<string>>;
  isAddingCard: boolean;
  isShowingPlaceholders: boolean;
}

export const MarketDataCardState = {
  NEW_CARD: 'NEW_CARD',
  UPDATED_CARD: 'UPDATED_CARD',
} as const;

export interface MarketDataCardConfig {
  id: string;
  symbol?: string;
  /** If true, the card will populate one market account per market on first render and then clear the flag. */
  initializeMarketAccounts?: boolean;
  view: CardViewEnum;
  state: keyof typeof MarketDataCardState;
  title?: string;
  /** 1-indexed. 1=VolumeLadder, 2=PriceLadder, 3=CandleStick, 4=Markets */
  activeSlideIndex: number;
  /** The market accounts that are available to be selected for this card. Selected on the card settings page. */
  availableMarketAccounts: string[];
  /** The market accounts that are currently selected for this card. Changeable on the markets slide. */
  selectedMarketAccounts: string[];
  /** The markets that are available to be selected for this card. Selected on the card settings page. */
  availableMarkets: string[];
  /** The markets that are currently selected for this card. Changeable on the markets slide. */
  selectedMarkets: string[];
  unifiedLiquidityMarketSymbols?: MarketDataCardUnifiedLiquidityMarket[];
  detailsExpanded?: boolean;
  topOfBookSizeBucket: string;
  sizeBuckets: string[];
  priceIncrement: string;
  unifiedLiquidity?: UnifiedLiquidityEnum;
  alwaysDisplayBestBidOffer?: boolean;
  resolution?: ResolutionEnumNoPrefix;
  orderPresetID?: string;
  selectedAggregation?: string;
  subAccount?: string;
}

export interface MarketDataCardUnifiedLiquidityMarket {
  marketAccount: string;
  symbol: string;
}
